import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocalTrendsFacade } from '../local-trends.facade';

@Component({
  selector: 'app-local-trends',
  templateUrl: './local-trends.component.html',
  styleUrls: ['./local-trends.component.scss'],
})
export class LocalTrendsComponent implements OnInit, OnDestroy {
  localTrendsLoaderStatus = true;
  localTrendsForZipUrl = null;
  zipCodeList = [];
  setInitialTab: number;
  onDestroyNotifier$ = new Subject();

  constructor(
    public localTrendsFacade: LocalTrendsFacade,
    private sanitizer: DomSanitizer,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.localTrendsFacade
      .getZipCodeList()
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res) => {
        if (res) {
          this.zipCodeList = res;
          this.setInitialTab = 0;
          this.getLocalTrends(res[0]);
        }
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  getLocalTrends(postalCode) {
    this.localTrendsLoaderStatus = true;
    this.localTrendsForZipUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://apps.propmix.io/mci/?' +
        'auth_token=7f0fc94c130b5135f8ecbfdbe7f50f9e55ded58e8eeaf9a11c50628d839ea06c' +
        '&zip=' +
        postalCode +
        '&monthsback=18&showGraphs=%5BMedianListPrice,MedianSoldPrice,DOM,MedianSoldPricePerSqFt,' +
        'Inventory,MedianListPriceVsMedianSoldPrice,InventoryAndAbsorptionRate%5D&head=&map=false&column=2&formfields='
    );
    this.localTrendsLoaderStatus = false;
    this.changeDetectorRef.detectChanges();
  }

  onClose() {
    this.localTrendsFacade.closeLocalTrendsSheet(false);
  }

  tabChanged(event) {
    if (event && event.tab && event.tab.textLabel) {
      this.getLocalTrends(event.tab.textLabel);
      this.setInitialTab = event.index;
    }
  }
}
